import { OnboardingGroup, OnboardingStep } from './types'

export const onboardingGroups: OnboardingGroup[] = [
  {
    id: 'product',
    title: 'Product experience',
    description: 'Build the reusable pricing, model, profile, and decoration-area setup.',
  },
  {
    id: 'media',
    title: 'Content library',
    description: 'Prepare the graphics and fonts customers can use while personalizing products.',
  },
  {
    id: 'store',
    title: 'Store foundation',
    description: 'Confirm the store settings and publish the customer-facing theme after reviewing the complete flow.',
  },
]

export const onboardingSteps: OnboardingStep[] = [
  {
    id: 'configure-store',
    groupId: 'store',
    signalId: 'storeConfigured',
    title: 'Configure your store',
    description: 'Review the machine workflow, profile version, customization limits, profanity rules, logo, and brand color.',
    actionLabel: 'Open store settings',
    route: '/themes?tab=Customizer%20Config',
    guideSectionId: 'store-settings',
    estimatedMinutes: 5,
  },
  {
    id: 'create-graphic-category',
    groupId: 'media',
    signalId: 'graphicCategoryCreated',
    title: 'Create a graphic category',
    description: 'Organize artwork into a customer-friendly category and choose where it should appear.',
    actionLabel: 'Add graphic category',
    route: '/media',
    guideSectionId: 'graphic-categories',
    estimatedMinutes: 3,
  },
  {
    id: 'add-font',
    groupId: 'media',
    signalId: 'fontAdded',
    title: 'Add a font',
    description: 'Upload at least one font family and verify its style and preview before activating it.',
    actionLabel: 'Add font',
    route: '/media?tab=Fonts',
    guideSectionId: 'fonts',
    estimatedMinutes: 4,
  },
  {
    id: 'create-view-profile',
    groupId: 'product',
    signalId: 'viewProfileCreated',
    title: 'Create a View Profile',
    description: 'Upload a verified GLB model and select the UV projection used by 3D product profiles.',
    actionLabel: 'Create View Profile',
    route: '/products?tab=View%20Profiles',
    guideSectionId: 'product-models',
    estimatedMinutes: 5,
  },
  {
    id: 'create-pricing-model',
    groupId: 'product',
    signalId: 'pricingModelCreated',
    title: 'Create a pricing model',
    description: 'Choose a pricing strategy and define the limits and rules used for personalization.',
    actionLabel: 'Create pricing model',
    route: '/products?tab=Pricing',
    guideSectionId: 'pricing',
    estimatedMinutes: 4,
  },
  {
    id: 'create-product-profile',
    groupId: 'product',
    signalId: 'sectionCreated',
    title: 'Create a product profile and section',
    description: 'Create the Color or Laser profile, connect its View Profile and pricing model, then continue in the same setup to add its first decoration section.',
    actionLabel: 'Create product setup',
    route: '/products',
    guideSectionId: 'product-profiles',
    estimatedMinutes: 10,
  },
  {
    id: 'publish-theme',
    groupId: 'store',
    signalId: 'themePublished',
    title: 'Publish a theme',
    description: 'Review the complete customer flow, then publish the theme that should be used by this store.',
    actionLabel: 'Review themes',
    route: '/themes',
    guideSectionId: 'themes',
    estimatedMinutes: 5,
  },
]
